export default __webpack_public_path__ + "static/humans3-dddbed89492e2766809d003040b3e9a8.png";